export default "/images/43a897762417c5610c11bf2c8f464c67.avif";